module.exports = __webpack_public_path__ + "media/customizations/ranchlife/back-8955f7ccfd111aac3596df37e1037115.jpg";